import { Injectable } from '@angular/core';
import { IUseState, UseService } from '@df/util/service/use.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class BottomPanelService {
    constructor(private useService: UseService) { }
    private toGlobalId(id: string): string {
        return ['bottomPanel', id].join();
    }
    onShow(id: string, source: any) {
        id && this.useService.lock(this.toGlobalId(id), source);
    }
    onHide(id: string, source: any) {
        id && this.useService.unlock(this.toGlobalId(id), source);
    }
    observe(id: string): BehaviorSubject<boolean> {
        return this.useService.getState(this.toGlobalId(id)).obs;
    }
    getState(id: string): IUseState {
        return this.useService.getState(this.toGlobalId(id));
    }
}
